import { render, staticRenderFns } from "./TransferDuration.vue?vue&type=template&id=24426dba&lang=pug&"
import script from "./TransferDuration.vue?vue&type=script&lang=ts&"
export * from "./TransferDuration.vue?vue&type=script&lang=ts&"
import style0 from "./TransferDuration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports